export const DOMAIN = 'auth.customer.dsar.forms';
